import axios from '@/utils/http'

/**
 *
 * 获取菜谱列表
 * @export
 * @param {*} params
 * @returns
 */
export function getMenuList(params) {
  return axios({
    url: '/MenuService/MenuManage/GetMenu',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取菜品类型 --主食，炒菜，粥汤---
 * @export
 * @param {*} params
 * @returns
 */
export function getMenuType(params) {
  return axios({
    url: '/MenuService/MenuManage/GetMenuType',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 新增菜谱
 * @export
 * @param {*} params
 * @returns
 */
export function addMenu(params) {
  return axios({
    url: '/MenuService/MenuManage/AddMenu',
    processData: false,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    },
    method: 'post',
    data: params
  })
}

/**
 *
 * 修改菜谱
 * @export
 * @param {*} params
 * @returns
 */
export function editMenu(params) {
  return axios({
    url: '/MenuService/MenuManage/EditMenu',
    processData: false,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    },
    method: 'post',
    data: params
  })
}

/**
 *
 * 删除菜谱
 * @export
 * @param {*} params
 * @returns
 */
export function delMenu(params) {
  return axios({
    url: '/MenuService/MenuManage/RemoveMenu',
    method: 'post',
    data: params
  })
}

/**
 *
 * 获取食材下拉列表(模糊查询)
 * @export
 * @param {*} params
 * @returns
 */
export function GetFoodByName(params) {
  return axios({
    url: '/MenuService/MenuManage/GetFoodByName',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 检测菜品食材是否营养
 * @export
 * @param {*} params
 * @returns
 */
export function MenuFoodTest(params) {
  return axios({
    url: '/MenuService/MenuManage/MenuTesting',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 添加菜品的食材组成
 * @export
 * @param {*} params
 * @returns
 */
export function AddMenuFood(params) {
  return axios({
    url: '/MenuService/MenuManage/AddMenuComponent',
    method: 'post',
    data: params
  })
}

/**
 *
 * 获取菜品的食材
 * @export
 * @param {*} params
 * @returns
 */
export function GetMenuFoods(params) {
  return axios({
    url: '/MenuService/MenuManage/GetMenuFoods',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取公共菜品库
 * @export
 * @param {*} params
 * @returns
 */
export function getPublicMenuList(params) {
  return axios({
    url: '/MenuService/MenuManage/GetCommonMenus',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 导入公共菜品到我的菜品库
 * @export
 * @param {*} params
 * @returns
 */
export function importMenuToOwn(params) {
  return axios({
    url: '/MenuService/MenuManage/ImportMenu',
    method: 'post',
    data: params
  })
}

/**
 * 获取菜品详情
 * @param {*} params
 */
export function getPublicMenuDetail(params) {
  return axios({
    url: '/AccountManageService/CommonMenuManage/GetCommonMenuFoods',
    method: 'GET',
    params: params
  })
}
